/**
 * Helper para convertir rutas de imagen del backend a URLs accesibles
 */

const apiUrl = process.env.REACT_APP_BUSINESS_BACKEND_URL;
if (!apiUrl) {
  throw new Error(
    "REACT_APP_BUSINESS_BACKEND_URL environment variable is not set"
  );
}
const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
export const DEFAULT_LOGO_URL = `${publicUrl}/img/logo.svg`;

/**
 * Convierte una ruta de imagen del backend a una URL HTTP accesible
 *
 * @param {string} imagePath - Ruta devuelta por el backend
 * @returns {string} - URL HTTP accesible
 *
 * Ejemplos:
 * - "C:\Users\...\uploads\1\logo.png" → "http://localhost:8080/uploads/1/logo.png"
 * - "/uploads/1/logo.png" → "http://localhost:8080/uploads/1/logo.png"
 * - "http://..." → "http://..." (sin cambios)
 */
export const convertToImageUrl = (imagePath) => {
  if (!imagePath) {
    return DEFAULT_LOGO_URL;
  }

  const normalizedPath = String(imagePath).replace(/\\/g, "/");

  // Si ya es una URL HTTP completa, devolverla tal cual
  if (normalizedPath.startsWith("http://") || normalizedPath.startsWith("https://")) {
    return normalizedPath;
  }

  const uploadsIndex = normalizedPath.indexOf("/uploads/");
  if (uploadsIndex >= 0) {
    return `${apiUrl}${normalizedPath.substring(uploadsIndex)}`;
  }

  const relativeUploadsIndex = normalizedPath.indexOf("uploads/");
  if (relativeUploadsIndex >= 0) {
    return `${apiUrl}/${normalizedPath.substring(relativeUploadsIndex)}`;
  }

  // Si es una ruta local de Windows (contiene : o \), usar imagen por defecto
  if (normalizedPath.includes(":")) {
    return DEFAULT_LOGO_URL;
  }

  // Si es una ruta relativa Unix (/uploads/...)
  if (normalizedPath.startsWith("/uploads/")) {
    return `${apiUrl}${normalizedPath}`;
  }

  // Si es solo "uploads/..." sin barra inicial
  if (normalizedPath.startsWith("uploads/")) {
    return `${apiUrl}/${normalizedPath}`;
  }

  // Si empieza con /api/, probablemente es una ruta del backend
  if (normalizedPath.startsWith("/api/")) {
    return `${apiUrl}${normalizedPath}`;
  }

  // Fallback: usar imagen por defecto
  return DEFAULT_LOGO_URL;
};

/**
 * Agrega cache busting a una URL de imagen
 */
export const addCacheBuster = (url) => {
  if (!url) return null;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${new Date().getTime()}`;
};

/**
 * Convierte y agrega cache busting en un solo paso
 */
export const getImageUrl = (imagePath) => {
  const url = convertToImageUrl(imagePath);
  if (url === DEFAULT_LOGO_URL) {
    return DEFAULT_LOGO_URL;
  }
  return addCacheBuster(url);
};
